import JokerProHeader from "../../components/header/JokerVideoHeader";
import { useTranslation } from "react-i18next";
import AssetsPack from "../../util/AssetsPack";
import Footer from "../../components/footer/Footer";
import MainTemplate from "../Templates/MainTemplate";
import style from "./JokerRewards.module.css";
import { ButtonSize, ButtonType, JokerButton } from "material-ui-jokerpro";
import PromoInformationCard from "./component/PromoInformationCard";
import {
  rewardInformationSectionItems,
  rewardsPromoSettingInfo,
  rewardsRedeemCards,
} from "../../util/CollectionData";
import TwoToneHeading, {
  TwoToneHeadingTextAlign,
  TwoToneHeadingTextSize,
} from "../../components/TwoToneHeading";
import Paragraph, { ParagraphSize } from "../../components/Paragraph";
import InformationSection from "../../components/InformationSection";
import RedeemCard from "./component/RedeemCard";
import JokerHorizontalList from "../../components/JokerHorizontalList";
import TwoToneHorizontalSectionChild from "../../components/TwoToneHorizontalSectionChild";

const JokerRewards = () => {
  const { t } = useTranslation();

  const header = (
    <JokerProHeader
      headerText={t("joker_rewards.tag")}
      title={t("joker_rewards.title_tone_1")}
      highlightLabel={t("joker_rewards.title_tone_2")}
      description={t("joker_rewards.sub_title")}
      bgImage={AssetsPack.image.BG_JOKER_REWARDS_HEADER}
      image={AssetsPack.image.JOKER_REWARDS_HEADER}
      isDownloadTagNotVisible
    >
      <div className={style["header-button-container"]}>
        <JokerButton
          text={t("global_component.get_started")}
          type={ButtonType.CTA}
          size={ButtonSize.Medium}
          href="/learn"
          icon={AssetsPack.icons.ICON_GO.default}
          equal
        />
      </div>
    </JokerProHeader>
  );

  const settingSuccess = (
    <div className={style["setting-information-container"]}>
      <div className={style["setting-sub-container"]}>
        <div className={style["setting-title-container"]}>
          <TwoToneHeading
            primaryText={t("joker_rewards.setting_promo.promo_title_tone1")}
            secondaryText={t("joker_rewards.setting_promo.promo_title_tone2")}
            textSize={TwoToneHeadingTextSize.heading2}
            textAlign={TwoToneHeadingTextAlign.left}
          />
        </div>
        <Paragraph size={ParagraphSize.paragraph2}>
          {t("joker_rewards.setting_promo.description")}
        </Paragraph>

        <div className={style["setting-promo-container"]}>
          {rewardsPromoSettingInfo.map((item, index) => (
            <PromoInformationCard
              key={index}
              title={item.title}
              description={item.description}
            />
          ))}
        </div>
      </div>
    </div>
  );

  const body = (
    <div className={style["body-container"]}>
      <div className={style["information-section-container"]}>
        <InformationSection
          titleTone1={t("joker_rewards.unlock_reward.title_1")}
          titleTone2={t("joker_rewards.unlock_reward.title_2")}
          description={t("joker_rewards.unlock_reward.description")}
          items={rewardInformationSectionItems()}
        />
      </div>

      <div className={style["redeem-container"]}>
        <TwoToneHorizontalSectionChild
          titleTone1={t("joker_rewards.redeem.title_1")}
          titleTone2={t("joker_rewards.redeem.title_2")}
          description={t("joker_rewards.redeem.description")}
        >
          <JokerHorizontalList
            items={rewardsRedeemCards}
            isBlurEffectEnable={true}
            showArrowIndicator={false}
            showScrollbar={false}
            renderItem={(game: any, index, isHovered) => (
              <div key={index} className={style["cardWrapper"]}>
                <RedeemCard
                  key={index}
                  isHovered={isHovered}
                  tagName={game.tagName}
                  title={game.title}
                  description={game.description}
                  image={game.image}
                />
              </div>
            )}
          />
        </TwoToneHorizontalSectionChild>
      </div>
      {settingSuccess}
    </div>
  );

  return (
    <MainTemplate
      body={body}
      footer={<Footer />}
      header={header}
      fullWidthHeaderIpad
    />
  );
};

export default JokerRewards;
